import { articleGraphQL } from '@/query/article/render-article'

const createQuery = () => `
query ($id: String!, $url: String!, $page: Int = 1) {
  articlesRelatedToArticle(id: $id, url: $url, page: $page) {
    total
    results {
      ${articleGraphQL}
    }
  }
}`

export default createQuery
